export default __webpack_public_path__ + "static/media/pantry1-afterC-2048w.8894ab0d.png";